import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';

import { grantPaymentPermissions, editEntityField } from '../../../actions';

class PermissionsEditor extends Component {

    handleSubmit = (event) => {
        this.props.grantPaymentPermissions(this.props.company.id, this.props.worker.userId, this.props.entity);
        event.preventDefault();
    }

    render() {
        if (!this.props.entity) {
            return null;
        }

        const permission = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>

                <Form.Field>
                    <label>{i18next.t('permissionReceiver')}</label>
                    <Dropdown
                        required
                        fluid
                        selection
                        search
                        options={this.props.workers.map((worker) => ({ value: worker.userId, text: worker.name }))}
                        value={permission.recipientUserId || ''}
                        onChange={(e, { value }) => this.props.editEntityField('recipientUserId', value)}
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('paymentPermission.useOnce')}
                        checked={Boolean(permission.useOnce)}
                        onChange={(e, { checked }) => this.props.editEntityField('useOnce', checked)}
                    />
                </Form.Field>

                <Form.Group>
                    <Button type='submit' primary floated="right">
                        {i18next.t('save')}
                    </Button>
                </Form.Group>

            </Form>
        );
    }
}

PermissionsEditor.propTypes = {
    company: PropTypes.object,
    grantPaymentPermissions: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object,
    workers: PropTypes.array,
    worker: PropTypes.object
    
};

const mapStateToProps = (state, ownProps) => {
    const { entity } = state.editor;
    const workers = state.budgetsApp.workers.filter(worker =>
        worker.userId !== ownProps.worker.userId &&
        !(ownProps.worker.permissions || []).find(p => p.recipientUserId === worker.userId)
    );

    return { entity, workers };
};

export default connect(mapStateToProps, { grantPaymentPermissions, editEntityField })(PermissionsEditor);
